@let post = post$ | async;
@let commentFullScreen = commentFullScreenEditor();
@let communityCapabilities = communityCapabilities$ | async;
@if (post && commentFullScreen) {
    <div
        animate.enter="animate-fade-in"
        animate.leave="animate-fade-out"
        cdkTrapFocus
        cdkTrapFocusAutoCapture
        class="fixed inset-0 z-20 flex items-center justify-center bg-dialog-layer motion-reduce:animate-none"
    >
        <interacta-post-comment-input
            class="w-676"
            [canViewWorkflow]="
                !!post.metadata?.workflowDefinition &&
                !!communityCapabilities?.viewWorkflowHistory
            "
            [createMention]="communityCapabilities?.createMention"
            [draft]="post.commentDraft"
            [initialViewMode]="'extended'"
            [isFullScreen]="true"
            [locationType]="commentFullScreen.location"
            [post]="post"
        />
    </div>
}
